
import React from 'react';

interface CopilotIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}

/**
 * Custom Copilot icon component
 * A square face icon with eyes and smile
 */
const CopilotIcon: React.FC<CopilotIconProps> = ({ 
  size = 24, 
  strokeWidth = 2,
  className = ""
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`lucide lucide-copilot ${className}`}
    >
      <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
      <path d="M9 9h.01"/>
      <path d="M15 9h.01"/>
    </svg>
  );
};

export default CopilotIcon;
